import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { getRatingText } from "src/components/utility/Reviews";

const OverallReviewRating = ({
  hotelOverallReviewRating,
  language
}: {
  hotelOverallReviewRating: number;
  language?: string[];
}) => (
  <span className="uitk-type-bold all-r-margin-one hotelRating">
    {[hotelOverallReviewRating.toLocaleString(language, { maximumFractionDigits: 1 })]}
    /5
  </span>
);

const RatingTextAndReviewCount = ({
  hotelOverallReviewRating,
  language,
  reviewCount
}: {
  hotelOverallReviewRating: number;
  reviewCount: number;
  language?: string[];
}) => {
  const l10nMessage = `hotels.review.${reviewCount > 1 ? "reviewCountPlural" : "reviewCountSingular"}`;

  return (
    <span className="uitk-type-300">
      {getRatingText(hotelOverallReviewRating)} (
      <LocalizedText
        message={l10nMessage}
        data={[reviewCount.toLocaleString(language, { maximumFractionDigits: 1 })]}
      />
      )
    </span>
  );
};

export const ReviewCountAndRating = ({
  hotelOverallReviewRating,
  reviewCount,
  language
}: {
  hotelOverallReviewRating: number;
  reviewCount: number;
  language?: string[];
}) => {
  if (!hotelOverallReviewRating || !reviewCount) {
    return (
      <div className="uitk-type-300">
        <LocalizedText message="hotels.review.noReviews" />
      </div>
    );
  }

  return (
    <div className="uitk-type-300 truncate">
      <OverallReviewRating hotelOverallReviewRating={hotelOverallReviewRating} language={language} />
      <RatingTextAndReviewCount
        hotelOverallReviewRating={hotelOverallReviewRating}
        language={language}
        reviewCount={reviewCount}
      />
    </div>
  );
};
